module.exports = __webpack_public_path__ + "static/img/propaganda-2.2414b087.jpeg";